import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import PressPostSummary from './PressPostSummary'
import Button from './Button'

const DEFAULT_MAX_SHOWING = 4
const SHOW_MORE_INCREMENT = 4

const PressPosts = class PressPosts extends Component {
  constructor () {
    super()
    this.state = {
      maxShowing: 9999 // for server side rendering
    }
  }
  componentDidMount () {
    this.setState({ maxShowing: DEFAULT_MAX_SHOWING })
  }
  render () {
    const { posts } = this.props
    const { maxShowing } = this.state
    return (
      <div>
        <ul>
          {posts
            .slice(0, maxShowing)
            .map(
              (
                {
                  date,
                  title: { rendered: title },
                  acf: { thumbnail: { url: image }, source, sourceTitle },
                  id
                },
                index
              ) => {
                if (!/^http(s)?/.test(source.trim())) {
                  source = 'http://' + source.trim()
                }
                return (
                  <li className='mb3' key={id}>
                    <PressPostSummary
                      date={date}
                      sourceLink={source}
                      sourceTitle={sourceTitle}
                      readMoreLink={source}
                      title={title}
                      image={image}
                    />
                  </li>
                )
              }
            )}
        </ul>
        {posts.length > maxShowing && (
          <Button
            className='button button--line button--red button--wide'
            onClick={() => {
              this.setState({
                maxShowing: this.state.maxShowing + SHOW_MORE_INCREMENT
              })
            }}
          >
            Show More
          </Button>
        )}
      </div>
    )
  }
}

PressPosts.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      acf: PropTypes.shape({
        thumbnail: PropTypes.object.isRequired,
        source: PropTypes.string.isRequired,
        sourceTitle: PropTypes.string
      }).isRequired,
      readMoreLink: PropTypes.string,
      title: PropTypes.shape({
        rendered: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  ).isRequired
}

export default connect()(PressPosts)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/PressPosts.js